(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  class ProductReviews extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-list]');
      if (!this.list) return;
      this.items = [...this.list.querySelectorAll('[data-review]')];
      this.pageSize = Number(this.dataset.pageSize) || 5;
      this.shown = this.pageSize;
      this.rating = null;
      this.mediaOnly = false;
      this.sort = 'newest';
      try {
        this.strings = JSON.parse(this.querySelector('[data-review-strings]').textContent);
      } catch (e) {
        this.strings = {};
      }

      this.querySelector('[data-toolbar]')?.removeAttribute('hidden');
      this.status = this.querySelector('[data-status]');
      this.empty = this.querySelector('[data-empty]');
      this.loadMore = this.querySelector('[data-load-more]');

      this.querySelectorAll('[data-filter-rating]').forEach((bar) => {
        bar.addEventListener('click', () => {
          const value = Number(bar.dataset.filterRating);
          this.rating = this.rating === value ? null : value;
          this.querySelectorAll('[data-filter-rating]').forEach((b) =>
            b.setAttribute('aria-pressed', String(Number(b.dataset.filterRating) === this.rating))
          );
          this.shown = this.pageSize;
          this.render();
          this.list.closest('.reviews__main')?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
      });

      this.querySelector('[data-sort]')?.addEventListener('change', (event) => {
        this.sort = event.target.value;
        this.shown = this.pageSize;
        this.render();
      });

      this.querySelector('[data-media-only]')?.addEventListener('change', (event) => {
        this.mediaOnly = event.target.checked;
        this.shown = this.pageSize;
        this.render();
      });

      this.loadMore?.addEventListener('click', () => {
        const firstNew = this.visible[this.shown];
        this.shown += this.pageSize;
        this.render();
        firstNew?.querySelector('button, a, h3')?.focus?.();
      });

      this.querySelectorAll('[data-more]').forEach((button) => {
        button.addEventListener('click', () => {
          const text = button.previousElementSibling;
          const expanded = button.getAttribute('aria-expanded') === 'true';
          text.classList.toggle('is-clamped', expanded);
          button.setAttribute('aria-expanded', String(!expanded));
          button.textContent = expanded ? this.strings.readMore : this.strings.readLess;
        });
      });

      this.setupLightbox();
      this.render();
    }

    render() {
      let items = this.items.filter(
        (item) =>
          (this.rating === null || Number(item.dataset.rating) === this.rating) &&
          (!this.mediaOnly || Number(item.dataset.media) > 0)
      );
      const byIndex = (a, b) => Number(a.dataset.index) - Number(b.dataset.index);
      const byTime = (a, b) => Number(b.dataset.time) - Number(a.dataset.time) || byIndex(a, b);
      const sorters = {
        newest: byTime,
        highest: (a, b) => Number(b.dataset.rating) - Number(a.dataset.rating) || byTime(a, b),
        lowest: (a, b) => Number(a.dataset.rating) - Number(b.dataset.rating) || byTime(a, b),
        media: (a, b) => Number(b.dataset.media > 0) - Number(a.dataset.media > 0) || byTime(a, b),
      };
      items.sort(sorters[this.sort] || byTime);
      this.visible = items;

      this.items.forEach((item) => (item.hidden = true));
      items.forEach((item, i) => {
        this.list.appendChild(item);
        item.hidden = i >= this.shown;
      });

      const showing = Math.min(this.shown, items.length);
      if (this.status) {
        this.status.textContent = (this.strings.showing || '')
          .replace('[shown]', showing)
          .replace('[total]', items.length);
      }
      if (this.empty) this.empty.hidden = items.length > 0;
      if (this.loadMore) this.loadMore.hidden = this.shown >= items.length;

      requestAnimationFrame(() => this.updateClamps());
    }

    updateClamps() {
      this.items.forEach((item) => {
        if (item.hidden) return;
        const text = item.querySelector('[data-review-text]');
        const button = item.querySelector('[data-more]');
        if (!text || !button || button.getAttribute('aria-expanded') === 'true') return;
        text.classList.add('is-clamped');
        button.hidden = text.scrollHeight <= text.clientHeight + 2;
      });
    }

    setupLightbox() {
      this.dialog = this.querySelector('[data-lightbox]');
      if (!this.dialog) return;
      this.stage = this.dialog.querySelector('[data-lightbox-stage]');
      this.counter = this.dialog.querySelector('[data-lightbox-counter]');
      this.prev = this.dialog.querySelector('[data-lightbox-prev]');
      this.next = this.dialog.querySelector('[data-lightbox-next]');

      this.querySelectorAll('[data-lightbox-item]').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          this.gallery = [...thumb.closest('.review__media').querySelectorAll('[data-lightbox-item]')];
          this.opener = thumb;
          this.show(this.gallery.indexOf(thumb));
          this.dialog.showModal();
        });
      });

      this.prev.addEventListener('click', () => this.show(this.current - 1));
      this.next.addEventListener('click', () => this.show(this.current + 1));
      this.dialog.querySelector('[data-lightbox-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog || event.target === this.stage) this.dialog.close();
      });
      this.dialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') this.show(this.current - 1);
        if (event.key === 'ArrowRight') this.show(this.current + 1);
      });
      this.dialog.addEventListener('close', () => {
        this.stage.innerHTML = '';
        this.opener?.focus();
      });
    }

    show(index) {
      if (!this.gallery || index < 0 || index >= this.gallery.length) return;
      this.current = index;
      const item = this.gallery[index];
      this.stage.innerHTML = '';
      if (item.dataset.type === 'video') {
        const template = document.getElementById(item.dataset.videoId);
        if (template) this.stage.appendChild(template.content.cloneNode(true));
        this.stage.querySelector('video')?.play().catch(() => {});
      } else {
        const img = document.createElement('img');
        img.src = item.dataset.src;
        img.alt = item.dataset.alt || '';
        this.stage.appendChild(img);
      }
      this.prev.hidden = index === 0;
      this.next.hidden = index === this.gallery.length - 1;
      this.counter.textContent = `${index + 1} / ${this.gallery.length}`;
    }
  }

  if (!customElements.get('product-reviews')) customElements.define('product-reviews', ProductReviews);

  } catch(e) { console.error(e); }
})();
})();
